import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import {Box, CardMedia, Grid, Typography} from '@mui/material';

import {DreamEmployerBar} from '../culture/dashboard/components/DreamEmployer/DreamEmployerBar';
import {DreamEmployerBarLegacy} from '../culture/dashboard/components/DreamEmployer/DreamEmployerBarLegacy/DreamEmployerBarLegacy';
import {isLegacyDreamEmployer} from '../culture/dashboard/components/DreamEmployer/DreamEmployerUtils/isLegacyDreamEmployer';

import {bodyPdf, pdfH1} from './styles';
import dreamEmployerImage from '../../../assets/pdf/dream_employer.png';
import {CultureAnalysisPdfContext} from '../../../contexts/CultureAnalysisPdfContext/CultureAnalysisPdfContext';
import {greenColors, orangeColors} from '../../../layouts/theme/designSystem';

export const DreamEmployer = () => {
  const {t} = useTranslation('pdfDomain');
  const {t: ts} = useTranslation('pdfDomain', {keyPrefix: 'dreamEmployer.bulletPoints'});

  const {data, loading} = useContext(CultureAnalysisPdfContext);

  if (loading || !data) {
    return null;
  }

  const dreamEmployerData = data.dreamEmployerResults;

  return (
    <Grid container p={5}>
      <Typography variant='h1' sx={pdfH1} mb={3}>
        {t('dreamEmployer.title')}
      </Typography>
      <Typography variant='body1' sx={bodyPdf} mb={5}>
        {t('dreamEmployer.textBlock')}
      </Typography>
      <Grid item container direction={'column'} ml={1}>
        <Typography sx={bodyPdf}>&#8226; {ts('one')}</Typography>
        <Typography sx={bodyPdf}>&#8226; {ts('two')}</Typography>
        <Typography sx={bodyPdf}>&#8226; {ts('three')}</Typography>
        <Typography sx={bodyPdf}>&#8226; {ts('four')}</Typography>
        <Typography sx={bodyPdf}>&#8226; {ts('five')}</Typography>
      </Grid>
      <Grid item container justifyContent={'center'} position={'relative'}>
        <CardMedia component='img' image={dreamEmployerImage} sx={{borderRadius: '16px', mt: 5}} />
        {!isLegacyDreamEmployer(dreamEmployerData) ? (
          <Box position={'absolute'} bottom={30} width={'95%'}>
            <DreamEmployerBar
              dreamEmployerData={dreamEmployerData}
              backgroundColor={orangeColors[4]}
              fillColorGradientIcon={orangeColors[4]}
              fillColorRibbonIcon={greenColors[700]}
              typographyStyles={{fontSize: '30px', color: greenColors[700], fontWeight: 'bold'}}
              iconSize={{height: '30px', width: '30px'}}
              isPdf
              height='190px'
            />
          </Box>
        ) : (
          <Box position={'absolute'} bottom={16} width={'680px'}>
            <DreamEmployerBarLegacy
              dreamEmployerData={dreamEmployerData}
              backgroundColor={orangeColors[900]}
              fillColorGradientIcon={orangeColors[900]}
              fillColorRibbonIcon={orangeColors[40]}
              typographyStyles={{fontSize: '30px', color: 'white', fontWeight: 'bold'}}
              iconSize={{height: '30px', width: '30px'}}
            />
          </Box>
        )}
      </Grid>
    </Grid>
  );
};
